import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const businessLabelSerializeMap: SerializeMap<BusinessLabel> = {
  id: "id",
  name: "name",
  archetype: "archetype",
  created: "created",
  lastModified: "last_modified",
  permissions: "permissions",
};

export const serializeBusinessLabel = buildSerializer(
  businessLabelSerializeMap,
  "businessLabel",
);

export const deserializeBusinessLabel = buildDeserializer<BusinessLabel>(
  businessLabelSerializeMap,
  "businessLabel",
);
